<template>
  <div class="no-data" :style="{ height: height }">
    <div class="no-data-inner">
      <img src="../../assets/common/noData.png" :style="iconStyle" alt="">
      <slot>
        <div style="color:#0065FF;">没有数据</div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "no-data",
  props: {
    height: {
      type: [Number, String],
      default: "500px"
    },
    iconWidth: {
      type: String,
      default: "180px"
    }
  },
  computed: {
    iconStyle() {
      return {
        width: this.iconWidth
      };
    }
  }
};
</script>

<style scoped lang="less">
.no-data {
  position: relative;
  &-inner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
}
</style>
